export default __webpack_public_path__ + "static/apple-touch-icon-c8a187a7d9ed91f9bcb39aa0ba434511.png";